<template>
  <div style="margin: 5px">
    <Wp_card>
      <div v-if="giftData.denomination">
        <div class="gift_title">
          {{ giftData.couponTitle }}
        </div>
        <div>
          礼金面额:{{ giftData.denomination }}元
        </div>
        <div>
          礼金总张数:{{ giftData.amount }}
        </div>
        <div>
          领取日期:{{ giftData.receiveStartTime }} 至 {{ giftData.receiveEndTime }}
        </div>
        <div>
          消费者领取后的有效期天数:{{ giftData.effectiveDays }}
        </div>
      </div>
      <div v-else>
        未找到礼金信息
      </div>
<!--      <div style="text-align: center">-->
<!--        <AnimeScale>-->
<!--          <van-button type="primary" @click="test">测试</van-button>-->
<!--        </AnimeScale>-->
<!--      </div>-->
    </Wp_card>
  </div>
</template>
<script>
import Wp_card from '../waps_ui/wp_card'
import AnimeScale from '../anime/AnimeScale'
import union_utils from '../../js/union_utils'

export default {
  components: { AnimeScale, Wp_card },
  props: {
    giftData: {}
  },
  methods: {
    test () {
      this.$union_utils.showCopyDialog('复制', '复制下方链接\nhttp://kumob.cn', 'http://kumob.cn')
    }
  }
}
</script>
<style>
.gift_title {
  font-size: 17px;
  font-weight: bold;
  color: #EE0A24;
}
</style>